import { ICropFavoriteInfo } from '../../api/crop-trends/getCropFavorite';

interface IFindCropFavoriteParams {
  largeCategoryCode: string;
  middleCategoryCode: string;
  smallCategoryCode: string;
  cropFavoritesInfos: ICropFavoriteInfo[];
}

interface IFindCropFavoriteReturn {
  isFavoriteCrop: boolean;
  wholesaleMarketCodes: string[];
}

export const findCropFavorite = ({
  largeCategoryCode,
  middleCategoryCode,
  smallCategoryCode,
  cropFavoritesInfos,
}: IFindCropFavoriteParams): IFindCropFavoriteReturn => {
  const filteredCropFavoritesInfos = cropFavoritesInfos.filter(
    (crop) =>
      crop.categorySmall.externalCode === smallCategoryCode &&
      crop.categorySmall.categoryMiddle.externalCode === middleCategoryCode &&
      crop.categorySmall.categoryMiddle.categoryLarge.externalCode === largeCategoryCode,
  );

  const isFavoriteCrop = filteredCropFavoritesInfos && filteredCropFavoritesInfos.length > 0;
  const wholesaleMarketCodes = filteredCropFavoritesInfos.map((favoriteInfo) => favoriteInfo.agriMarket.externalCode);

  return {
    isFavoriteCrop,
    wholesaleMarketCodes,
  };
};
